import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1,
  class: "pl-2 px-6 pr-4 py-6"
};
const _hoisted_3 = {
  key: 0,
  class: "absolute inset-0 bg-gray-200 bg-opacity-50 z-50",
  style: {
    "cursor": "not-allowed"
  }
};
const _hoisted_4 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_5 = {
  class: "bg-gray-200 px-2 py-1"
};
const _hoisted_6 = ["href"];
const _hoisted_7 = {
  class: "grid grid-cols-12 gap-4"
};
const _hoisted_8 = {
  class: "col-span-4"
};
const _hoisted_9 = {
  class: "col-span-1 pt-10"
};
const _hoisted_10 = {
  class: "col-span-7"
};
const _hoisted_11 = {
  class: "flex flex-row"
};
const _hoisted_12 = {
  class: "w-6/12 flex flex-row"
};
const _hoisted_13 = {
  key: 0,
  class: "fa fa-angle-up",
  "aria-hidden": "true"
};
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = {
  class: "w-6/12 flex justify-end"
};
const _hoisted_16 = {
  key: 0,
  class: "table"
};
const _hoisted_17 = {
  class: "cursor-pointer"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  class: "input-append"
};
const _hoisted_20 = ["onUpdate:modelValue", "placeholder"];
const _hoisted_21 = {
  key: 0
};
const _hoisted_22 = {
  class: "input-append"
};
const _hoisted_23 = ["onUpdate:modelValue", "placeholder"];
const _hoisted_24 = {
  class: "input-append"
};
const _hoisted_25 = ["onUpdate:modelValue", "placeholder"];
const _hoisted_26 = {
  class: "cursor-pointer"
};
const _hoisted_27 = ["onClick"];
import { reactive, onMounted, ref, computed } from 'vue';
import RouteService from '@/services/RouteService';
import ListsService from '@/services/ListsService';
import ProductNotice from '@/components/ProductNotice.vue';
import LlButtonToggle from '@/components/LlButtonToggle.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import AllocationShareBar from './AllocationShareBar.vue';
import AllocationOptions from './AllocationOptions.vue';
import AllocationShare from './AllocationShare.vue';
import { useReportSettingsStore } from './useReportSettingsStore.js';
import MainHeader from '@/components/MainHeader.vue';
import SettingsSaveBar from '@/components/SettingsSaveBar.vue';
import { useSupportChat } from '@/composables/useSupportChat';
import CustomPlanCard from './components/CustomPlanCard.vue';
export default {
  __name: 'ReportsSettings',
  props: {
    userService: {
      type: Object,
      required: true
    },
    rootScope: {
      type: Object,
      required: true
    },
    modalService: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const {
      getSupportUrl
    } = useSupportChat();
    const revenueReportsUrl = computed(() => getSupportUrl('revenueReports'));
    const props = __props;
    let reportState = reactive({
      original: {
        accounts: [],
        me: {}
      },
      accounts: {},
      me: {},
      loading: false,
      lists: new ListsService(),
      form: {},
      tableDataChanged: false,
      unsaved: false,
      calculateTotalAutimaticallyError: false,
      showOriginationStepDown: false
    });
    const userAllocation = ref(false);
    const reportSettingsStore = useReportSettingsStore();
    const hasCustomPlan = computed(() => !!reportState.me.company?.settings?.report?.customPlan?.id);
    const noCompensation = computed(() => {
      return !reportState.me.features?.compensation;
    });
    reportSettingsStore.alerts = props.alerts;
    reportSettingsStore.$subscribe((mutation, storeState) => {
      reportState.saving = storeState.saving;
    });
    reportSettingsStore.$onAction(({
      name,
      after
    }) => {
      after(resolvedValue => {
        if (name === 'updateMyCompany') {
          reportState.me.company = reportSettingsStore.company;
          getMe();
        }
      });
    });
    onMounted(() => {
      getMe();
      const deactivate = new RouteService(props).rootScopeChange().$on('$stateChangeStart', event => {
        if (somethingChanged.value) {
          reportState.unsaved = true;
          setTimeout(() => {
            reportState.unsaved = false;
          }, 7000);
          event.preventDefault();
        } else {
          deactivate();
        }
      });
    });
    async function getMe() {
      reportState.loading = true;
      const [me, accounts] = await Promise.all([props.userService.getMe(), props.userService.list()]);
      reportState.accounts = accounts, reportState.me = me, reportState.original.accounts = accounts, reportState.original.me = me;
      reportState.loading = false;
      resetForm();
    }
    function resetForm() {
      reportState.form = reportSettingsStore.reportForm(reportState);
      reportState.showOriginationStepDown = !!reportState.form.originationStepDownPeriodInMonths;
      reportState.tableDataChanged = false;
      reportState.form.accounts = reportState.accounts.map(account => {
        const setting = reportState.form.accounts?.find(a => a.id === account.id) || {};
        setting.referrals = setting.referrals || [];
        setting.account = Object.assign(account);
        setting.id = account.id;
        return setting;
      });
      updateTotals();
    }
    function cancel() {
      reportState.accounts = reportState.original.accounts, reportState.me = reportState.original.me;
      resetForm();
    }
    function goToRevenueByAttorney() {
      new RouteService(props).go('reports.attorney-revenue', {}, false);
    }
    const somethingChanged = computed(() => {
      return reportSettingsStore.compare(reportState);
    });
    const userFilterItems = computed(() => [{
      label: 'All',
      value: false
    }, {
      label: `${reportState.lists.userRoleFromId('lead')}s`,
      value: true
    }]);
    const reportSettingFilter = computed(() => {
      return reportState.form.accounts.filter(a => !reportState.filter || a.account && (a.account.role === 'lead' || a.account.role === 'principal'));
    });
    function updateTotals() {
      reportState.form.accounts?.forEach(account => {
        account.originationTotal = account.origination || reportState.form.originatingContribution || 0;
        account.originationTotal += account.referrals.reduce((sum, r) => sum + r.referral, 0);
        if (account.referrals && account.referrals.length) {
          account.referrals.sort((a, b) => a.referral > b.referral ? -1 : 1);
          account.referralSummaries = account.referrals.map(r => {
            const referralAccount = reportState.accounts.find(a => a.id === r.id);
            return referralAccount && `${referralAccount.initials || referralAccount.name} ${r.referral}%`;
          });
        }
      });
    }
    function referral(setting) {
      props.modalService.showModal({
        template: require('../../../modals/referral/template.html'),
        inputs: {
          setting
        },
        bodyClass: 'show-modal-overlay',
        controller: 'ReferralModalController'
      }).then(modal => {
        modal.element.modal();
        return modal.close.then(updated => {
          if (updated) {
            setting.referrals = Object.assign(updated.referrals);
            reportState.tableDataChanged = true;
            updateTotals();
          }
          $('.modal-backdrop.in').remove();
        });
      });
    }
    function toggleAllocation(setting) {
      if (setting.revenueToResponsible) {
        setting.revenueToResponsible = false;
        setting.revenueToExpenses = true;
      } else if (setting.revenueToExpenses) {
        setting.revenueToExpenses = false;
      } else {
        setting.revenueToResponsible = true;
      }
      reportState.tableDataChanged = true;
      updateTotals();
    }
    function originatingContributionChange() {
      reportState.tableDataChanged = true;
    }
    function update() {
      if (!reportState.showOriginationStepDown) {
        reportState.form.originationStepDownPeriodInMonths = null;
      }
      if (!reportState.form.useMostRecentDate) {
        reportState.form.useMostRecentDateCutoff = null;
      }
      reportSettingsStore.update(reportState.form);
    }
    const showOriginationStepDown = showOriginationStepDown => {
      if (!showOriginationStepDown) {
        reportState.form.originationStepDownPeriodInMonths = 0;
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [noCompensation.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ProductNotice, {
        state: __props.state,
        label: 'Revenue allocation reports (and the following options) are',
        trial: true,
        product: 'compensation'
      }, null, 8, ["state"])])) : _createCommentVNode("", true), _unref(reportState).me.terms ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
        class: _normalizeClass({
          relative: noCompensation.value
        })
      }, [noCompensation.value ? (_openBlock(), _createElementBlock("div", _hoisted_3)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createVNode(MainHeader, {
        content: "Compensation Tracking and Report Settings"
      }), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_5, [_cache[9] || (_cache[9] = _createElementVNode("span", {
        class: "fa fa-exclamation-circle text-primary pr-2"
      }, null, -1)), _cache[10] || (_cache[10] = _createTextVNode("These settings affect the ", -1)), _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => goToRevenueByAttorney(), ["prevent"])),
        class: "cursor-pointer"
      }, "Revenue by " + _toDisplayString(_unref(reportState).me.terms.Lead), 1), _cache[11] || (_cache[11] = _createTextVNode(" reports ", -1)), _createElementVNode("a", {
        class: "p-2",
        href: revenueReportsUrl.value,
        target: "_blank",
        rel: "noopener noreferrer"
      }, [...(_cache[8] || (_cache[8] = [_createElementVNode("span", {
        class: "text-primary font-medium"
      }, " Documentation ", -1)]))], 8, _hoisted_6)])])]), _cache[23] || (_cache[23] = _createElementVNode("hr", null, null, -1)), hasCustomPlan.value ? (_openBlock(), _createBlock(CustomPlanCard, {
        key: 1
      })) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(AllocationShare, {
        state: _unref(reportState),
        alerts: __props.alerts
      }, null, 8, ["state", "alerts"])]), _createElementVNode("div", _hoisted_9, [_createVNode(AllocationShareBar, {
        form: _unref(reportState).form,
        calculateTotalAutimaticallyError: _unref(reportState).calculateTotalAutimaticallyError
      }, null, 8, ["form", "calculateTotalAutimaticallyError"])]), _createElementVNode("div", _hoisted_10, [_createVNode(AllocationOptions, {
        state: _unref(reportState),
        onShowOriginationStepDown: showOriginationStepDown
      }, null, 8, ["state"])])]), _cache[22] || (_cache[22] = _createElementVNode("hr", null, null, -1)), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_cache[12] || (_cache[12] = _createElementVNode("h4", null, "Revenue Allocation for Users", -1)), _createVNode(LlSecondaryButton, {
        "aria-label": userAllocation.value ? 'Hide users allocation' : 'Show users allocation',
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => userAllocation.value = !userAllocation.value, ["prevent"]))
      }, {
        default: _withCtx(() => [userAllocation.value ? (_openBlock(), _createElementBlock("i", _hoisted_13)) : _createCommentVNode("", true), !userAllocation.value ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Show Users Allocation")) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["aria-label"])]), _createElementVNode("div", _hoisted_15, [_withDirectives(_createVNode(LlButtonToggle, {
        modelValue: _unref(reportState).filter,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(reportState).filter = $event),
        items: userFilterItems.value,
        "aria-label": "Users shown",
        density: "compact"
      }, null, 8, ["modelValue", "items"]), [[_vShow, userAllocation.value]])])]), userAllocation.value ? (_openBlock(), _createElementBlock("table", _hoisted_16, [_createElementVNode("thead", null, [_createElementVNode("tr", null, [_cache[13] || (_cache[13] = _createElementVNode("th", null, "User", -1)), _cache[14] || (_cache[14] = _createElementVNode("th", null, "Initials", -1)), _cache[15] || (_cache[15] = _createElementVNode("th", null, "Role", -1)), _cache[16] || (_cache[16] = _createElementVNode("th", null, "Allocation", -1)), _cache[17] || (_cache[17] = _createElementVNode("th", null, "Working", -1)), _withDirectives(_createElementVNode("th", null, "Working (Self Originated)", 512), [[_vShow, _unref(reportState).me.features.selfOrigination]]), _cache[18] || (_cache[18] = _createElementVNode("th", null, "Origination", -1)), _withDirectives(_createElementVNode("th", null, "Referrals", 512), [[_vShow, _unref(reportState).me.features.referral]]), _withDirectives(_createElementVNode("th", null, " Total Origination ", 512), [[_vShow, _unref(reportState).me.features.referral]])])]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportSettingFilter.value, (setting, idx) => {
        return _openBlock(), _createElementBlock("tr", {
          key: idx
        }, [_createElementVNode("td", null, _toDisplayString(setting.account.name), 1), _createElementVNode("td", null, _toDisplayString(setting.account.initials), 1), _createElementVNode("td", null, _toDisplayString(_unref(reportState).lists.userRoleFromId(setting.account.role)), 1), _createElementVNode("td", _hoisted_17, [_createElementVNode("a", {
          onClick: _withModifiers($event => toggleAllocation(setting), ["prevent"])
        }, _toDisplayString(_unref(reportSettingsStore).allocationLabel(setting)), 9, _hoisted_18)]), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_19, [_withDirectives(_createElementVNode("input", {
          type: "number",
          "onUpdate:modelValue": $event => setting.workingContribution = $event,
          style: {
            "width": "50%",
            "padding": "14px"
          },
          step: "any",
          placeholder: _unref(reportState).form.workingContribution,
          onChange: _cache[3] || (_cache[3] = _withModifiers($event => originatingContributionChange(), ["prevent"]))
        }, null, 40, _hoisted_20), [[_vModelText, setting.workingContribution]]), _cache[19] || (_cache[19] = _createElementVNode("span", {
          class: "add-on"
        }, "%", -1))])]), _unref(reportState).me.features.selfOrigination ? (_openBlock(), _createElementBlock("td", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_withDirectives(_createElementVNode("input", {
          type: "number",
          "onUpdate:modelValue": $event => setting.selfOrigination = $event,
          style: {
            "width": "50%",
            "padding": "14px"
          },
          step: "any",
          placeholder: _unref(reportState).form.selfOrigination,
          onChange: _cache[4] || (_cache[4] = _withModifiers($event => originatingContributionChange(), ["prevent"]))
        }, null, 40, _hoisted_23), [[_vModelText, setting.selfOrigination]]), _cache[20] || (_cache[20] = _createElementVNode("span", {
          class: "add-on"
        }, "%", -1))])])) : _createCommentVNode("", true), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_24, [_withDirectives(_createElementVNode("input", {
          type: "number",
          "onUpdate:modelValue": $event => setting.origination = $event,
          style: {
            "width": "50%",
            "padding": "14px"
          },
          step: "any",
          placeholder: _unref(reportState).form.originatingContribution,
          onChange: _cache[5] || (_cache[5] = _withModifiers($event => originatingContributionChange(), ["prevent"]))
        }, null, 40, _hoisted_25), [[_vModelText, setting.origination]]), _cache[21] || (_cache[21] = _createElementVNode("span", {
          class: "add-on"
        }, "%", -1))])]), _withDirectives(_createElementVNode("td", _hoisted_26, [_createElementVNode("a", {
          onClick: _withModifiers($event => referral(setting), ["prevent"])
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(setting.referralSummaries, (summary, idx) => {
          return _openBlock(), _createElementBlock("p", {
            key: idx
          }, _toDisplayString(summary), 1);
        }), 128)), _withDirectives(_createElementVNode("span", null, "add", 512), [[_vShow, !setting.referralSummaries?.length]])], 8, _hoisted_27)], 512), [[_vShow, _unref(reportState).me.features.referral]]), _withDirectives(_createElementVNode("td", null, _toDisplayString(setting.originationTotal), 513), [[_vShow, _unref(reportState).me.features.referral]])]);
      }), 128))])])) : _createCommentVNode("", true)], 64))], 2), !hasCustomPlan.value ? (_openBlock(), _createBlock(SettingsSaveBar, {
        key: 0,
        somethingChanged: somethingChanged.value,
        saving: _unref(reportState).saving,
        unsaved: _unref(reportState).unsaved,
        onUpdate: _cache[6] || (_cache[6] = $event => update()),
        onCancel: _cache[7] || (_cache[7] = $event => cancel()),
        disabled: noCompensation.value
      }, null, 8, ["somethingChanged", "saving", "unsaved", "disabled"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
    };
  }
};